/*
 * DRIVOS: Klaviyo "Ilmoita kun saapuu" -lomakkeen kielet.
 *
 * Klaviyo sallii vain yhden saapumisilmoituslomakkeen, joka on tehty suomeksi.
 * Tämä skripti:
 *  1) vaihtaa lomakkeen ja napin suomenkieliset tekstit sivun kielelle
 *     (lähde- ja käännöstekstit tulevat snippetistä drivos-klaviyo-bis-i18n.liquid),
 *  2) tallentaa lomakkeen lähetyksen yhteydessä profiiliin ominaisuuden drivos_kieli,
 *     jonka mukaan Klaviyon saapumisilmoitussähköposti valitsee kielen.
 * Tekstit tunnistetaan sisällön perusteella, ei Klaviyon luokkanimistä.
 * Jos jotain tekstiä ei tunnisteta, se jää suomeksi eikä mikään muu muutu.
 */
(function () {
  var dataEl = document.getElementById('drivos-bis-i18n');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var lang = (cfg.lang || 'fi').toLowerCase().split('-')[0];

  /* 2) Kieli profiiliin lomakkeen lähetyksessä (kaikilla kielillä, myös suomi).
   *    Kaksi reittiä: Klaviyon oma klaviyoForms-tapahtuma ja varalla lähetysnapin klikkaus
   *    Klaviyon ponnahduslomakkeessa (sähköposti luetaan kentästä). Kaksoiskutsu ei haittaa. */
  var lastSent = '';
  function sendLang(email) {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    var key = email.toLowerCase() + '|' + lang;
    if (key === lastSent) return;
    lastSent = key;
    var props = { $email: email, drivos_kieli: lang };
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(props);
      } else {
        (window._learnq = window._learnq || []).push(['identify', props]);
      }
    } catch (err) { /* ei estä tilausta */ }
  }
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'submit') return;
    var m = d.metaData || {};
    sendLang(m.$email || m.email || '');
  });
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button');
    if (!btn) return;
    var form = btn.closest('[role="dialog"] form');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    if (input) sendLang((input.value || '').trim());
  }, true);

  if (lang === 'fi') return;

  /* 1) Tekstien käännös */
  var norm = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
  var stripTags = function (html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return norm(div.textContent);
  };

  /* Liquidin t-suodatin muuttaa esim. heittomerkin muotoon &#39;, joten puretaan entiteetit tavallisista teksteistä. */
  var decode = function (s) {
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  };

  var textMap = {};
  var htmlMap = {};
  Object.keys(cfg.source || {}).forEach(function (key) {
    var from = cfg.source[key];
    var to = cfg.t && cfg.t[key];
    if (!from || !to) return;
    if (/_html$/.test(key)) {
      if (stripTags(from) !== stripTags(to)) htmlMap[stripTags(from)] = to;
    } else {
      to = decode(to);
      if (norm(from) !== norm(to)) textMap[norm(from)] = to;
    }
  });
  if (!Object.keys(textMap).length && !Object.keys(htmlMap).length) return;

  var ATTRS = ['placeholder', 'aria-label', 'title', 'value'];

  function translateEl(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (!el.hasAttribute(a)) continue;
      if (a === 'value' && !(el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type))) continue;
      var v = textMap[norm(el.getAttribute(a))];
      if (v) el.setAttribute(a, v);
    }
    /* Vain P-elementti: Klaviyon tekstilohko on aina <p>, eikä ylempiä kääreitä saa korvata. */
    if (el.tagName === 'P') {
      var h = htmlMap[norm(el.textContent)];
      if (h && el.querySelector('a')) {
        el.innerHTML = h;
        var link = el.querySelector('a');
        if (link) link.style.color = 'inherit';
      }
    }
  }

  function translateTree(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      var t = textMap[norm(root.nodeValue)];
      if (t) root.nodeValue = t;
      return;
    }
    if (root.nodeType !== 1) return;
    translateEl(root);
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) translateEl(all[i]);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var tr = textMap[norm(n.nodeValue)];
      if (tr) n.nodeValue = tr;
    }
  }

  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var list = pending;
    pending = [];
    for (var i = 0; i < list.length; i++) translateTree(list[i]);
  }
  function queue(node) {
    pending.push(node);
    if (!scheduled) {
      scheduled = true;
      setTimeout(flush, 0); /* ei requestAnimationFramea: se ei aja taustavälilehdellä */
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) queue(m.addedNodes[j]);
      } else if (m.type === 'characterData') {
        queue(m.target);
      } else if (m.type === 'attributes') {
        queue(m.target);
      }
    }
  });

  function start() {
    translateTree(document.body);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
